import { MatchForecast } from './MatchForecast';
import { Tip } from './Tip';

export type Validity = {
  isValid: boolean;
  errorMsg: string;
};
export type DefaultMatchValidation = {
  match: Validity;
  tip: Validity;
  formatted_odds: Validity;
  market: Validity;
};
export type CustomMatchValidation = {
  home_player: Validity;
  away_player: Validity;
  start_date: Validity;
  sport: Validity;
  competition_name: Validity;
  tip: Validity;
  formatted_odds: Validity;
  market: Validity;
};
export type StepsType = 'step1' | 'step2' | 'step3' | 'step4';
const steps: StepsType[] = ['step1', 'step2', 'step3', 'step4'];
export class Validations {
  step1: {
    matchForecasts: (DefaultMatchValidation | CustomMatchValidation)[];
    stake: Validity;
    bookie: Validity;
    accumulatedOdds: Validity;
    isValid: boolean;
  };
  step2: {
    isValid: boolean;
  };
  step3: {
    isValid: boolean;
  };
  step4: {
    betImage: Validity;
    isValid: boolean;
  };
  constructor(matchForecasts: MatchForecast[]) {
    this.step1 = this.step1DefaultValidity(matchForecasts);
    this.step2 = this.step2DefaultValidity();
    this.step3 = this.step3DefaultValidity();
    this.step4 = this.step4DefaultValidity();
  }

  private step1DefaultValidity(matchForecasts: MatchForecast[]) {
    const matchForecastsValidity = matchForecasts.map((matchForecast) => {
      if (matchForecast.type === 'DEFAULT') {
        return {
          match: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          tip: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          formatted_odds: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          market: {
            isValid: true,
            errorMsg: '',
          },
        };
      } else {
        return {
          home_player: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          away_player: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          start_date: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          sport: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          competition_name: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          tip: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          formatted_odds: {
            isValid: false,
            errorMsg: 'Empty field',
          },
          market: {
            isValid: false,
            errorMsg: 'Empty field',
          },
        };
      }
    });
    return {
      matchForecasts: matchForecastsValidity,
      stake: {
        isValid: true,
        errorMsg: '',
      },
      bookie: {
        isValid: true,
        errorMsg: '',
      },
      accumulatedOdds: {
        isValid: false,
        errorMsg: 'Empty field',
      },
      isValid: false,
    };
  }
  private step2DefaultValidity() {
    return { isValid: true };
  }
  private step3DefaultValidity() {
    return {
      isValid: true,
    };
  }
  private step4DefaultValidity() {
    return {
      betImage: {
        isValid: false,
        errorMsg: 'Empty field',
      },
      isValid: false,
    };
  }
  public runValidations(tip: Tip) {
    type tipValidationFieldsType = 'stake' | 'bookie' | 'accumulatedOdds';
    const tipValidationFields: tipValidationFieldsType[] = [
      'stake',
      'bookie',
      'accumulatedOdds',
    ];
    //reset validations
    this.step1 = this.step1DefaultValidity(tip.matchForecasts);
    this.step2 = this.step2DefaultValidity();
    this.step3 = this.step3DefaultValidity();
    this.step4 = this.step4DefaultValidity();
    // common checks
    tipValidationFields.forEach((field) => {
      this.step1[field] = this.isFieldEmpty(tip[field]);
    });
    //stake check
    if (tip.stake === 0) {
      this.step1.stake = {
        isValid: false,
        errorMsg: 'Empty field',
      };
    }

    tip.matchForecasts.forEach(
      (matchForecast: MatchForecast, index: number) => {
        const furtherDefaultMatchesValidations: (keyof DefaultMatchValidation)[] =
          ['tip', 'match', 'formatted_odds'];

        const furtherCustomMatchesValidations: (keyof CustomMatchValidation)[] =
          [
            'home_player',
            'away_player',
            'competition_name',
            'tip',
            'formatted_odds',
          ];
        const isDefault = tip.matchForecasts[index].type === 'DEFAULT';
        const isMatchForecastEmpty = () => {
          type DefaultChecksType = 'match_id' | 'tip' | 'formatted_odds';
          const DEFAULT_CHECKS: DefaultChecksType[] = [
            'match_id',
            'tip',
            'formatted_odds',
          ];
          type CustomCheksType =
            | 'home_player'
            | 'away_player'
            | 'competition_name'
            | 'tip'
            | 'formatted_odds';
          const CUSTOM_CHECKS: CustomCheksType[] = [
            'home_player',
            'away_player',
            'competition_name',
            'tip',
            'formatted_odds',
          ];
          let isEmpty = true;
          if (isDefault) {
            DEFAULT_CHECKS.forEach((key) => {
              if (key === 'formatted_odds') {
                if (tip.matchForecasts[index].formatted_odds.decimal) {
                  isEmpty = false;
                  return;
                }
              } else if (tip.matchForecasts[index][key]) {
                isEmpty = false;
                return;
              }
            });
          } else {
            CUSTOM_CHECKS.forEach((key) => {
              if (key === 'formatted_odds') {
                if (tip.matchForecasts[index].formatted_odds.decimal) {
                  isEmpty = false;
                  return;
                }
              } else if (tip.matchForecasts[index][key]) {
                isEmpty = false;
                return;
              }
            });
          }

          return isEmpty;
        };
        const setValidationsToValid = (
          validationFields:
            | (keyof DefaultMatchValidation)[]
            | (keyof CustomMatchValidation)[],
          index: number,
        ): void =>
          validationFields.forEach((key) => {
            //@ts-ignore
            this.step1.matchForecasts[index][key] = {
              isValid: true,
              errorMsg: '',
            };
          });

        if (matchForecast.type === 'DEFAULT') {
          //default matchForecast checks
          const defaultMatchForecastValidationFields: Array<
            keyof DefaultMatchValidation
          > = ['tip', 'formatted_odds', 'market'];

          const matchForecastValidity = this.step1.matchForecasts[
            index
          ] as DefaultMatchValidation;
          matchForecastValidity.match = this.isFieldEmpty(
            matchForecast.home_player,
          );
          defaultMatchForecastValidationFields.forEach((field) => {
            matchForecastValidity[field] = this.isFieldEmpty(
              //@ts-ignore
              matchForecast[field],
            );
          });
          if (index >= 2 && isMatchForecastEmpty()) {
            setValidationsToValid(furtherDefaultMatchesValidations, index);
          }
        } else {
          //custom matchForecast checks
          const customMatchForecastValidationFields: Array<
            keyof CustomMatchValidation
          > = [
            'tip',
            'formatted_odds',
            'market',
            'home_player',
            'away_player',
            'start_date',
            'sport',
            'competition_name',
          ];
          const matchForecastValidity = this.step1.matchForecasts[
            index
          ] as CustomMatchValidation;
          customMatchForecastValidationFields.forEach((field) => {
            matchForecastValidity[field] = this.isFieldEmpty(
              matchForecast[field],
            );
          });
          //START_DATE CUSTOM CHECK
          const startDate = new Date(tip.matchForecasts[index].start_date);
          const currentDate = new Date();
          if (
            startDate.getUTCFullYear() <= currentDate.getUTCFullYear() &&
            startDate.getUTCMonth() <= currentDate.getUTCMonth() &&
            startDate.getUTCDate() <= currentDate.getUTCDate() &&
            startDate.getUTCHours() <= currentDate.getUTCHours() &&
            startDate.getUTCMinutes() <= currentDate.getUTCMinutes()
          ) {
            matchForecastValidity.start_date = {
              isValid: false,
              errorMsg: 'INVALID_DATE',
            };
          } else
            matchForecastValidity.start_date = {
              isValid: true,
              errorMsg: '',
            };

          if (index >= 2 && isMatchForecastEmpty()) {
            setValidationsToValid(furtherCustomMatchesValidations, index);
          }
        }
      },
    );

    this.step4.betImage = this.isFieldEmpty(tip.betImage);
    //check steps overall validity
    this.step1.isValid = this.checkValidity(this.step1);
    this.step3.isValid = this.checkValidity(this.step3);
    this.step4.isValid = this.checkValidity(this.step4);
  }
  private checkValidity(obj: any): boolean {
    const keys = Object.keys(obj);
    let foundInvalid = false;
    keys.forEach((key) => {
      if (key === 'matchForecasts') {
        obj[key].forEach((matchForecast: any) => {
          (Object.keys(matchForecast) as (keyof MatchForecast)[]).forEach(
            (matchForecastKey: keyof MatchForecast) => {
              if (matchForecast[matchForecastKey].isValid === false) {
                return (foundInvalid = true);
              }
            },
          );
        });
      } else if (obj[key].isValid === false) {
        return (foundInvalid = true);
      }
    });
    return !foundInvalid;
  }
  public checkStepValidity(stepNumber: number): boolean {
    const step: StepsType = steps[stepNumber];
    return this[step].isValid;
  }
  private isFieldEmpty(value: any): Validity {
    if (value instanceof File) {
      return {
        isValid: true,
        errorMsg: '',
      };
    }
    if (value === '' || value === null || value === undefined || value === 0) {
      return {
        isValid: false,
        errorMsg: 'Empty field',
      };
    } else if (value instanceof Object) {
      const key = Object.keys(value)[0];
      return this.isFieldEmpty(value[key]);
    }
    return {
      isValid: true,
      errorMsg: '',
    };
  }
}
